import { useSyncExternalStore } from "react";

const subscribe = () => () => {};

/**
 * 프리렌더한 HTML 을 hydrate 하는 첫 렌더에서만 false, 그 뒤와 일반 클라이언트 렌더에서는 true.
 *
 * 로그인 여부처럼 브라우저에만 있는 값(localStorage)으로 글자가 바뀌는 곳에 쓴다. 빌드 때
 * 프리렌더는 늘 "로그아웃" 상태로 그려지므로, hydrate 하는 순간 그 값을 바로 쓰면 마크업이
 * 어긋나 React 가 그 구간을 통째로 다시 그린다. 앱 안에서 이동해 그릴 때는 처음부터 true 라
 * 깜빡이지 않는다.
 */
export function useHydrated(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => true,
    () => false
  );
}
